import { section } from "@/neon";

section("custom-content", {
  onLoad() {},
  onUnload() {},
});
